<script>
export default {
  props: {
    petId: {
      type: [String, Number],
      required: true,
    },
    activeId: {
      type: [Number, String],
      default: '',
    },
    memberInfo: {
      type: Object,
      required: true,
    },
    products: {
      type: Array,
      default: () => [],
    },
    setServicesMemberLevelPrice: {
      type: Function,
      required: true
    },
  },
  data() {
    return {
      clickIndex: 0, // 使用者點選到的list index
      qtyArr: [],
      filteredServices: [], // 服務列表
    }
  },
  computed: {
    multipleStore() {
      return this.products.length > 1
    },
    petSizeId() {
      return this.memberInfo.pets.find(item => this.petId === item.id).sizeId
    },
  },
  mounted() {
    this.filteredServices = this.filteredServicesFunc()
    this.filteredServices.forEach(() => this.qtyArr.push(1))
  },
  methods: {
    /**
     * @description 組出服務列表
     */
    filteredServicesFunc() {
      // 過濾出適合寵物體型的服務
      if (this.petSizeId) {
        let services = []
        this.products.forEach((product) => {
          const list = product.prices.map(priceItem => ({
            ...priceItem,
            storeTitle: product.title,
            productId: product.id,
            discount: null,
            discountType: null,
            isScheduleItemPrice: ''
          }))
            .filter(({ sizeId }) => sizeId === this.petSizeId)

          services = [...services, ...list]
        })
        // 如果有會員等級，在渲染時要先預處理
        if (this.memberInfo.level) {
          const { servicePrices } = this.memberInfo.level
          services = this.setServicesMemberLevelPrice(services, servicePrices)
        }
        return services
      } else {
        return []
      }
    },
    /**
     * @description 改變radio
     */
    changeRadio(item) {
      try {
        this.clickIndex = this.filteredServices.findIndex(filterItem => filterItem.id === item.id)
        let count = this.qtyArr[this.clickIndex] === 0 ? 1 : this.qtyArr[this.clickIndex]
        this.$set(this.qtyArr, this.clickIndex, count) // 畫面上的數量陣列
        this.$set(item, 'qty', count) // 實際上點選到的服務項目的物件，為其加上qty
        this.$emit('selected', this.decideEmitPrice(item))
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 決定最後要往上傳的price是多少
     */
    decideEmitPrice(item) {
      try {
        let cloneItem = Object.assign({}, item)
        if (cloneItem['isScheduleItemPrice'] === 'scheduleItemPrice') {
          cloneItem['price'] = cloneItem['scheduleItemPrice']
        }
        return cloneItem
      } catch (error) {
        console.error(error.message)
      }
    },
    onClickClose() {
      this.$emit('close')
    },
    /**
     * @description 點選到服務項目
     */
    onClickService(item) {
      try {
        let cloneItem = Object.assign({}, item)
        this.clickIndex = this.filteredServices.findIndex(filterItem => filterItem.id === item.id)
        cloneItem.qty = this.qtyArr[this.clickIndex]
        this.$emit('selected', this.decideEmitPrice(cloneItem))
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 加減服務項目
     */
    onClickAddMinus(item, status) {
      try {
        if (this.qtyArr[this.clickIndex] === 0 && status === 'minus') {
          return
        }
        this.clickIndex = this.filteredServices.findIndex(filterItem => filterItem.id === item.id)
        let count = 0
        if (status === 'plus') {
          count = this.qtyArr[this.clickIndex] + 1
        }
        if (status === 'minus') {
          count = this.qtyArr[this.clickIndex] - 1
        }
        this.$set(this.qtyArr, this.clickIndex, count) // 畫面上的數量陣列
        this.$set(item, 'qty', count) // 實際上點選到的服務項目的物件，為其加上qty
        this.$emit('selected', this.decideEmitPrice(item))
      } catch (error) {
        console.error(error.message)
      }
    }
  },
}
</script>
<template>
  <div :class="$style.orderformSection">
    <div class="orderformSection__right__header">
      <button class="el-drawer__close-btn" aria-label="close drawer" type="button" @click="onClickClose"><i
          class="el-dialog__close el-icon el-icon-close"></i></button>
      <h4 class="orderformSection__right__title">選擇服務</h4>
    </div>
    <div class="orderformSection__right__content">
      <template v-if="filteredServices.length > 0">
        <div v-for="(item, index) in filteredServices" :key="index"
          :class="[[$style.serviceList], { isActive: index === clickIndex }]" @click="onClickService(item)">
          <div :class="$style.bottomBorder">
            <div :class="$style['serviceList__imgText']">
              <!-- 左上角圖片 -->
              <div>
                <el-image :class="$style['serviceList__imgText__img']" :src="item.image" fit="cover">
                  <div slot="error">
                    <BaseIcon name="image" class="image--error" />
                  </div>
                </el-image>
              </div>
              <!-- 圖片右邊文字 -->
              <div :class="$style['serviceList__rightText']">
                <div class="fw-medium" :class="$style['serviceList__rightText__title']">
                  <span v-if="multipleStore">{{ item.storeTitle }}</span> {{ item.title }}
                </div>
                <div class="text-text-light fs-2sm mb-1">{{ item.sizeTitle }} </div>
                <div>
                  <BaseIcon name="clock" icon-style="fal" class="mr-2" />{{ item.serviceTime }}分鐘
                </div>
                <div>
                  <template v-if="item['discount'] !== null && item['discount'] > 0">
                    <del class="line-through-price">售價：{{ item.price }}</del>
                  </template>
                </div>
              </div>
            </div>
            <div>
              <div :class="$style.radioDisplay">
                <el-radio v-model="item['isScheduleItemPrice']" label="price" :class="{
                  [$style.radioDisplay__item]: true,
                  [$style.radioDisplay__itemSelected]: item['isScheduleItemPrice'] === 'price' && index === clickIndex,
                }" @input="changeRadio(item)">
                  <template v-if="item['discount'] !== null && item['discount'] > 0">
                    <div class="text-primary Jost labelStyle">會員價</div>
                    <div class="text-primary Jost labelStyle">NT${{ item.levelPrice }}</div>
                  </template>
                  <template v-else>
                    <div class="text-primary Jost labelStyle">售價</div>
                    <div class="text-primary Jost labelStyle"> NT${{ item.price }} </div>
                  </template>
                </el-radio>
                <el-radio v-model="item['isScheduleItemPrice']" label="scheduleItemPrice" :class="{
                  [$style.radioDisplay__item]: true,
                  [$style.radioDisplay__itemSelected]: item['isScheduleItemPrice'] === 'scheduleItemPrice' && index === clickIndex,
                }" @input="changeRadio(item)">
                  <template v-if="item['discount'] !== null && item['discount'] > 0">
                    <div class="text-primary Jost labelStyle">指定美容師會員價</div>
                    <div class="text-primary Jost labelStyle">NT${{ item.scheduleItemLevelPrice }}</div>
                  </template>
                  <template v-else>
                    <div class="text-primary Jost labelStyle">指定美容師售價</div>
                    <div class="text-primary Jost labelStyle"> NT${{ item.scheduleItemPrice }} </div>
                  </template>
                </el-radio>
              </div>
            </div>
          </div>
          <div :class="$style['serviceList__qty']">
            <div>
              <div @click.stop="onClickAddMinus(item, 'minus')">-</div>
              <div>{{ qtyArr[index] }}</div>
              <div @click.stop="onClickAddMinus(item, 'plus')">+</div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <el-alert :title="`目前選擇的${$t('reserve.CLIENT')}不在排班人員的服務範圍之內`" type="warning" :closable="false"></el-alert>
      </template>
    </div>
  </div>
</template>
<style lang="scss" module>
@import '@design';

.orderformSection {
  :global {
    .orderformSection {

      &__right {
        position: relative;
        width: 43%;
        height: calc(100vh);
        overflow: hidden;

        .orderformSection__right__header {
          background-color: $color-line;
          z-index: 999;
        }

        &__title {
          margin: 0;
          padding: 19px 0;
          padding-left: 50px;
        }

        &__header {
          position: relative;
          border-bottom: $color-border-base 1px solid;

          .el-drawer__close-btn {
            // font-weight: 300;
            color: #72767b;
            position: absolute;
            padding: 15px;
            border: 0;
            left: 0;
            top: 3px;
          }

          .el-tabs__item {
            height: auto;
            padding: 10px 0;
          }

          .el-tabs__nav-wrap::after {
            display: none;
          }

          .el-tabs__header {
            margin-bottom: 0;
          }

          .el-tabs--top {
            margin-left: 60px;

            @include max-lg {
              margin-left: 30px;
            }
          }
        }

        &__content {
          z-index: 10;
          height: calc(100vh - 60px);
          overflow: auto;
          padding: 30px;
          padding-bottom: 120px;
          position: relative;
          background-color: $color-line;

          @include max-lg {
            padding: 20px;
          }
        }
      }
    }
  }
}

.bottomBorder {
  padding-bottom: 8px;
  border-bottom: $color-border-base 1px solid;
}

.price {
  display: flex;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: $color-border-base 1px solid;
  cursor: pointer;

  &:global {
    &:hover {
      .price__title {
        color: $color-primary;
        transition: all 0.35s;
      }
    }

    &.isDisabled {
      pointer-events: none
    }
  }

  :global {
    .price {
      cursor: pointer;

      &:hover {
        .price__title {
          color: $color-primary;
        }
      }

      &__image {
        width: 50%;
        height: 10vw;
        border: 0;
        border-radius: 8px;

        @include max-md {
          height: auto;
        }
      }

      &__cont {
        width: 50%;
        padding-left: 15px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-self: center;
      }

      &__title {
        font-weight: 500;
        margin-bottom: 10px;
        color: $color-secondary;
      }
    }

    .text-muted-0 {
      font-size: 14px;
    }
  }
}

.radioDisplay {
  display: flex;

  &__item {
    flex-grow: 1;
    height: 60px;
    display: flex;
    align-items: center;
    border: 1px solid $color-line-dark;
    border-radius: $border-radius;
    padding: 4px 8px;
    flex: 1;

    :global {
      .labelStyle {
        margin-top: 4px;
        margin-bottom: 4px;
      }
    }
  }

  &__itemSelected {
    border: 1px solid $color-primary;
  }
}

.serviceList {
  padding: 16px 18px 0;
  display: flex;
  flex-direction: column;
  height: auto;
  margin-bottom: 20px;
  background-color: white;
  border-radius: $border-radius;
  border: 1px solid $color-line-dark;

  &:global {

    &.isActive {
      border: 1px solid $color-primary;
    }
  }

  &__imgText {
    display: flex;
    width: 100%;
    // border-bottom: 1px dashed $color-line-dark;
    padding-bottom: 11.75px;

    >div:nth-child(1) {
      width: 40%;
      margin-right: 20px;
    }

    >div:nth-child(2) {
      width: 60%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    &__img {
      width: 100%;
      height: 91px;
      border-radius: 8px;
    }
  }

  &__rightText {
    &__title {
      font-size: 15.5px;
      color: $color-secondary;
    }

    div {
      margin-bottom: 10px;
    }
  }

  &__qty {
    height: 80px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    >div {
      display: flex;
      align-items: center;

      >div:nth-child(2n+1) {
        border: 1px solid $color-line-dark;
        border-radius: $border-radius;
        height: 44px;
        width: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
      }

      >div:nth-child(2n) {
        color: $color-secondary;
        font-size: 20px;
      }

      >div:first-child {
        margin-right: 23px;
      }

      >div:last-child {
        margin-left: 23px;
      }
    }
  }
}
</style>